// extracted by mini-css-extract-plugin
export default {"App":"home_App__fbQwo","mainContainer":"home_mainContainer__f0laO","subredditContainer":"home_subredditContainer__azJSL"};